import {
  STATISTICS_CSV,
  ADMIN_REDIRECT,
  STATISTICS_PIRSUM,
  STATISTICS_BANNER,
  DIVUR_REDIRECT
} from '@/lib/api.js';
export async function fetcCSV(axios) {
  const { data } = await axios.get(`${STATISTICS_CSV}`, {
    headers: {
      responseType: 'text/csv'
    }
  });

  const fileLink = document.createElement('a');
  fileLink.href = 'data:application/octet-stream;base64,' + data.FileAsBytes;
  fileLink.setAttribute('download', `${data.FileName}`);
  fileLink.setAttribute('class', `csvfile`);
  document.body.appendChild(fileLink);

  fileLink.click();
  if (data.IsRedirect) {
    window.location = '/';
  }
}

export async function redirect(axios, params) {
  try {
    return await axios.get(`${ADMIN_REDIRECT}?${params}`);
  } catch (err) {
    console.log(err);
  }
}
export async function pirsumstat(axios, params) {
  try {
    return await axios.get(`${STATISTICS_PIRSUM}?${params}`);
  } catch (err) {
    console.log(err);
  }
}

export async function bannerstat(axios, params) {
  try {
    return await axios.get(`${STATISTICS_BANNER}?${params}`);
  } catch (err) {
    console.log(err);
  }
}
export async function divurRedirect(axios, params) {
  try {
    const res = await axios.get(`${DIVUR_REDIRECT}?${params}`);

    return res.data;
  } catch (err) {
    console.log(err);
  }
}
